import React from 'react';
import PropTypes from 'prop-types';
import ToastBase from './ToastBase';

class Toast extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override TextInputBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <TextField> */
    className: PropTypes.string,
    /** Toast message */
    message: PropTypes.string.isRequired,
    /** Callback function for dismiss action */
    onDismiss: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <ToastBase styles={styles} {...otherProps} />;
  }
}

export default Toast;
